import React from 'react';
import { useTheme } from '@material-ui/styles';
import { useStyles } from './styles';
import { Grid, Typography, List, ListItem, Paper } from '@material-ui/core';


// Reporting class
const Reporting = props => {


    const theme = useTheme();
    const styles = useStyles(theme);

    const routeTo = route => {
        props.history.push(`/reporting/${route}`)
    }

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>

                

                <div className={styles.taskbar}>

                    <Typography variant="h4">Reporting</Typography>

                </div>
            
                <Grid container spacing={2}>
                    
                    <Grid item xs={12} sm={4} md={3}>
                        <Typography variant="h6">VendElectric</Typography>

                        <Paper className={styles.space}>
                            <List>
                                <ListItem button onClick={() => routeTo('wallet_balances')}>Wallet Balances</ListItem>
                                <ListItem button onClick={() => routeTo('wallet_transactions')}>All Wallet Transactions</ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    
                    <Grid item xs={12} sm={4} md={3}>
                        <Typography variant="h6">BerthVend</Typography>

                        <Paper className={styles.space}>
                            <List>
                                <ListItem button onClick={() => routeTo('bv/wallet_balances')}>Wallet Balances</ListItem>
                                <ListItem button onClick={() => routeTo('bv/wallet_transactions')}>All Wallet Transactions</ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    
                </Grid>
            </div>
        </div>
    )

}

export default Reporting
